import React from 'react';
import {Shimmer} from "@atoms/Loaders/Shimmer";


export const ResidenceExplorerLoader: React.FC = () => {
    return (
        <div>
            <Shimmer maxWidth height={1510}  />
        </div>
    );
};
